export default __webpack_public_path__ + "static/media/loadingBottom.5cc10f97.svg";